import React, { useEffect } from 'react'

import Header from './components/Header'

const LayerLayout = ({ children }) => {
    useEffect(() => {
        document.body.id = 'ipsa'
    }, [])

    useEffect(() => {
        return () => {
            document.body.id = null
        }
    }, [])

    return (
        <>
            {/* <Header /> */}
            <div id="main-page" className="col-section">
                {children}
            </div>
        </>
    )
}

export default LayerLayout
